import { useEffect, useState } from "react";

import { useServiceFormUiState } from "@/states/service-form/selectors";
import {
  ServiceFormCustomerInputKey,
  ServiceFormErrors,
  ServiceFormServiceInputKey,
} from "@/states/service-form/types";
import { useRouter } from "next/router";
import { NEXT_URL } from "@/utils/const";

type Props = {
  errors: ServiceFormErrors;
  name: ServiceFormCustomerInputKey | ServiceFormServiceInputKey;
};
export const FieldError = ({ errors, name }: Props) => {
  const serviceFormUiState = useServiceFormUiState();
  const [isSubmit, setIsSubmit] = useState(false);
  const router = useRouter();
  const isConfirm = router.pathname === NEXT_URL.FORM_CONFIRM;
  let fieldErrors = [];
  let isTouched = false;

  useEffect(() => {
    function handleChangeShowErrors() {
      if (!isSubmit) setIsSubmit(true);
    }
    window.addEventListener("button.handleFormSubmit", handleChangeShowErrors);
    return () =>
      window.removeEventListener(
        "button.handleFormSubmit",
        handleChangeShowErrors,
      );
  }, []);

  switch (name) {
    case "detailIds":
    case "optionIds":
    case "serviceMenuId":
    case "serviceMenuOptionIds":
    case "serviceMenuReservationDateTime":
      fieldErrors = errors.service[name] || [];
      isTouched = true;
      break;
    default:
      fieldErrors = errors.customer[name] || [];
      if (
        serviceFormUiState.status === "Loaded" &&
        serviceFormUiState.inputs.customer[name] !== undefined
      ) {
        isTouched = true;
      }
      if (isConfirm) {
        if (
          serviceFormUiState.status === "Loaded" &&
          serviceFormUiState?.draft?.inputs.customer[name] !== undefined
        ) {
          isTouched = true;
        }
      }
      break;
  }
  if (!fieldErrors.length) {
    return <></>;
  }
  if (fieldErrors.length && !(isSubmit || isTouched)) {
    return <div className={`form-error-text`} />;
  }

  return (
    <ul className={`form-error-text`}>
      {fieldErrors?.map((message, i) => (
        <li key={i} className="text-error-msg">
          {message}
        </li>
      ))}
    </ul>
  );
};
